//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import form from '~/mixins/components/form';

export default {
  name: 'booking-form-cabinet',
  mixins: [form],
  props: {
    searchPending: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    start: {
      type: Boolean,
      default: false,
    },
  },
};
